import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ModalBasic from "./ModalBasic.jsx";
import { gradientBorder } from "../../styles/mixin.js";
import useStore from "../../store.js";
import { useNavigate } from "react-router-dom";
import ModalPayCheck from "./ModalPayCheck.jsx";

const ModalAskFormSuggestion = ({
  isOpen,
  onClose,
  onConfirm,
  initialText,
  sourceLogId,
}) => {
  const [textValue, setTextValue] = useState(initialText || "");
  const [showPayCheckModal, setShowPayCheckModal] = useState(false);
  const navigate = useNavigate();
  const { 
    setHasAttemptedQuestion, 
    setTextValue: setStoreTextValue,
    startSSE
  } = useStore();

  // isOpen이 변경될 때마다 초기 텍스트로 리셋
  useEffect(() => {
    if (isOpen) {
      setTextValue(initialText || "");
    }
  }, [isOpen, initialText]);

  const handleTextChange = (e) => {
    setTextValue(e.target.value);
  };

  const handleClose = () => {
    setTextValue(initialText || ""); // 취소 시 초기 텍스트로 리셋
    onClose();
  };

  const handleComplete = (newLogId) => {
      navigate(`/main/q/${newLogId}`, { replace: true });
  };

  const handleSSEStart = () => {
    navigate(`/main/q/waiting`);
  };

  const handleConfirmClick = () => {
    // ModalAskFormSuggestion을 닫고 ModalPayCheck를 표시
    onClose();
    setShowPayCheckModal(true);
  };

  const handlePayCheckConfirm = () => {
    // 요청 결과 팝업과 겹치지 않도록 결제 확인 모달을 먼저 닫는다.
    setShowPayCheckModal(false);
    setStoreTextValue(textValue);
    setHasAttemptedQuestion();
    startSSE(textValue, handleComplete, handleSSEStart, { sourceLogId });
  };

  const inputCount = textValue.length;

  return (
    <>
      <ModalBasic
        isOpen={isOpen}
        onClose={handleClose}
        width={window.innerWidth > 430 ? "400px" : "312px"}
        height={window.innerWidth > 430 ? "611px" : "579px"}
        top="50%"
        left="50%"
        className="modal-ask-suggestion">
        <Wrapper>
          <TextWrapper>
            <Header>검색하기</Header>
            <Content>
              10로우가 차감됩니다.
              <br />
              계속 진행하시겠습니까?
            </Content>
            <SubHeader>
              완성된 질문입니다. 이곳에서 질문을 자유롭게 수정하신 후,
              확인 버튼을 눌러주세요
            </SubHeader>
            <TextAreaWrapper>
              <TextArea
                value={textValue}
                onChange={handleTextChange}
                maxLength="1000"
              />
              <TextCount>
                <CountText>{inputCount}</CountText>
                <span style={{ color: "rgba(0, 0, 0, 0.3)" }}> / 1000</span>
              </TextCount>
            </TextAreaWrapper>
            <AdditionalContent>
              사용자의 상황과 유사한 최대 5개의 판례를 검색 결과로 제공하며,
              검색 시마다 다른 결과를 얻을 수 있습니다.
            </AdditionalContent>
          </TextWrapper>
          <ButtonWrapper>
            <CancelButton onClick={handleClose}>취소</CancelButton>
            <ConfirmButton onClick={handleConfirmClick}>
              <ButtonInner>확인</ButtonInner>
            </ConfirmButton>
          </ButtonWrapper>
        </Wrapper>
      </ModalBasic>
      
      {/* 10로우 차감 확인 모달 */}
      <ModalPayCheck
        isOpen={showPayCheckModal}
        onClose={() => setShowPayCheckModal(false)}
        onConfirm={handlePayCheckConfirm}
        law={10}
        buttonType="queryButton"
        headerContent="검색하기"
        additionalContent={
          <span
            dangerouslySetInnerHTML={{
              __html:
                "사용자의 상황과 유사한 최대 5개의 판례를 검색 결과로<br />제공하며, 검색 시마다 다른 결과를 얻을 수 있습니다.",
            }}
          />
        }
      />
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const TextWrapper = styled.div``;

const Header = styled.div`
  color: rgba(0, 0, 0, 0.6);
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
`;

const Content = styled.div`
  color: #000;
  text-align: left;
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  margin-top: 8px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 4px;
  }
`;

const SubHeader = styled.div`
  width: 313px;
  color: rgba(0, 0, 0, 0.6);
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.28px;
  margin-top: 8px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    width: 215px;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

const TextAreaWrapper = styled.div`
  ${gradientBorder}
  position: relative;
  width: 336px;
  height: 283px;
  margin: 0 auto;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0px 4px 20px 5px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    width: 264px;
  }
`;

const TextArea = styled.textarea`
  width: 300px;
  height: 197px;
  margin: 24px 18px;
  padding: 0;
  border: none;
  font-family: Pretendard;
  font-size: 14px;
  line-height: 23px;
  resize: none;
  overflow-y: auto;

  &:focus {
    outline: none;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }

  @media (max-width: 768px) {
    width: 228px;
  }
`;

const TextCount = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const CountText = styled.span`
  color: #00F370;
  font-weight: 700;
`;

const AdditionalContent = styled.div`
  width: 307px;
  color: rgba(0, 0, 0, 0.4);
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-top: 8px;

  @media (max-width: 768px) {
    width: 259px;
    font-size: 12px;
    line-height: 20px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

const Button = styled.button`
  width: 70px;
  height: 40px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
`;

const CancelButton = styled(Button)`
  background: #F2F2F2;
  color: #000;
`;

const ConfirmButton = styled(Button)`
  background: #000;
  padding: 2px;
`;

const ButtonInner = styled.div`
  border: 1px solid rgba(0, 243, 112, 0.3);
  color: #00F370;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

export default ModalAskFormSuggestion;
